import { render, staticRenderFns } from "./PhyDiagRecord.vue?vue&type=template&id=a61e46b2"
import script from "./PhyDiagRecord.vue?vue&type=script&lang=js"
export * from "./PhyDiagRecord.vue?vue&type=script&lang=js"
import style0 from "./PhyDiagRecord.vue?vue&type=style&index=0&id=a61e46b2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a61e46b2')) {
      api.createRecord('a61e46b2', component.options)
    } else {
      api.reload('a61e46b2', component.options)
    }
    module.hot.accept("./PhyDiagRecord.vue?vue&type=template&id=a61e46b2", function () {
      api.rerender('a61e46b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/PhyDiagRecord.vue"
export default component.exports